export default "__VITE_ASSET__CwjWCvZt__"